 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axiossocial from '../../config/socialaxios'

const apiGetTagStat = async (keyword) => {
    try {
        const result = await axiossocial.get(`/feed/tag_stat`, {
            params: {
                keyword: keyword,
            },
        });
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.data]);
    }
};

export {
    apiGetTagStat,
}